/**
 * Décide de la ligne d'état affichée sous le numéro d'un appel.
 *
 * Trois écrans montrent cette information — le popup temps réel, l'historique
 * et l'écran de rappel. La règle vit ici, en un seul endroit : c'est déjà la
 * duplication du lookup côté backend qui rendait ce sujet coûteux à faire
 * évoluer, inutile de reproduire le motif côté React.
 *
 * Renvoie `{ text, tone }`, ou `null` quand il n'y a rien à dire — un appelant
 * identifié porte déjà son nom et sa société sur leurs propres lignes.
 */

const IDENTIFIED = ['user', 'company', 'crm_contact', 'multiple'];

export function describeCaller(call) {
  const matchType = call && call.match_type;
  if (!matchType) return null;

  // Une identification réussie prime toujours sur l'indice de préfixe.
  if (IDENTIFIED.includes(matchType)) return null;

  if (matchType === 'pending') {
    return { text: 'Identification en cours...', tone: 'muted' };
  }

  if (matchType === 'none') {
    const label = call.caller_hint && call.caller_hint.label;
    if (label) return { text: label, tone: 'warning' };
    return { text: 'Contact non identifié', tone: 'danger' };
  }

  return null;
}

/** Couleurs des trois tons, alignées sur la charte des écrans d'appel. */
export const HINT_TONES = {
  warning: { color: '#b45309', background: '#fffbeb' },
  danger: { color: '#dc2626', background: 'transparent' },
  muted: { color: '#6b7d8f', background: 'transparent' },
};
